import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  makeOrderCurrencyById,
  makeOrderProductsById,
} from '../../../redux/selectors/orderById';
import ProductListSection from './ProductListSection';

const mapStateToProps = (_initialOwnState, initialOwnProps) => {
  const transactionID = initialOwnProps.transactionID;
  const selector = createStructuredSelector({
    data: makeOrderProductsById(transactionID),
    currency: makeOrderCurrencyById(transactionID),
  });

  return state => selector(state);
};

export default connect(mapStateToProps, null)(ProductListSection);
